import React, { useState, useEffect } from "react";
import axios from "axios";
import { url } from "../Api/config";
import { close_svg } from '../Svg/svgs';
import "./Notifications.css";

const Notifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [newText, setNewText] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showForm, setShowForm] = useState(false);

    const fetchNotifications = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${url}/api/getnotifications`);
            if (response.data.res) {
                setNotifications(response.data.notifications);
            } else {
                setError("Ошибка при загрузке уведомлений");
                setTimeout(() => setError("") , 5000);
            }
        } catch (e) {
            setError("Ошибка сети");
            setTimeout(() => setError("") , 5000);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchNotifications();
    }, []);

    const handleCreate = async () => {
        if (!newText.trim()) {
            alert("Введите текст уведомления");
            return;
        }
        try {
            const formData = new FormData();
            formData.append("text", newText);
            const response = await axios.post(`${url}/api/createnotification`, formData);
            if (response.data.res) {
                setNewText("");
                setShowForm(false);
                fetchNotifications();
            } else {
                alert("Ошибка при создании уведомления");
            }
        } catch (e) {
            alert("Ошибка сети");
        }
    };

    return (
        <div style={{ maxWidth: "600px", margin: "20px auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                <h3 style={{ margin: 0 }}>Уведомления</h3>
                {!showForm &&<button
                    onClick={() => setShowForm(!showForm)}
                    style={{
                        padding: "8px 16px",
                        backgroundColor: "#888",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer"
                    }}
                >
                    Создать
                </button>}
            </div>
            <div
                style={{
                    overflow: "hidden",
                    maxHeight: showForm ? "200px" : "0",
                    transition: "max-height 0.4s ease",
                    marginBottom: showForm ? "20px" : "0"
                }}
            >
                <div style={{ position: "relative" }}>
                    <button
                        onClick={() => setShowForm(false)}
                        className="close-button"
                        aria-label="Закрыть форму создания уведомления"
                    >
                        {close_svg}
                    </button>
                    <textarea
                        value={newText}
                        onChange={(e) => setNewText(e.target.value)}
                        placeholder="Текст нового уведомления"
                        rows={6}
                        style={{boxSizing: 'border-box', width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ccc", resize: "vertical" }}
                    />
                    <button
                        onClick={handleCreate}
                        style={{
                            marginTop: "10px",
                            padding: "10px 20px",
                            backgroundColor: "#888",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer"
                        }}
                    >
                        Создать
                    </button>
                </div>
            </div>
            {loading && <p>Загрузка...</p>}
            {error && <p style={{ color: "red" }}>{error}</p>}
            <div>
                {notifications.map(({ id, text, created_at }) => (
                    <div
                        key={id}
                        style={{
                            backgroundColor: "#f5f5f5",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "15px",
                            marginBottom: "10px",
                            color: "#333",
                            boxShadow: "1px 1px 4px rgba(0,0,0,0.05)"
                        }}
                    >
                        <p>{text}</p>
                        <small style={{ color: "#666" }}>{new Date(created_at).toLocaleString()}</small>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Notifications;
